<div class="bulk-edt common-model-nav">
  <div class="row">
    <div class="col-8">
      <div (click)="navigateHomePage()" class="stk-back-btn">
        <mat-icon class="stk-bck-icon">keyboard_arrow_left</mat-icon>
        <span class="stk-bck-btn ">
          Back
        </span>
      </div>
    </div>
    <div class="col-4">
      <div class="stk-nav">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb" style="margin-top: 2%;margin-bottom: 0%;">
            <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Bulk Edit</li>
            <div>
              <button
                [attr.Pixel-tracking]="true"
                [attr.Pixel-title]="'Documentation'"
                class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon"
                matTooltipPosition="left"
                title="Info"
                (click)="showInfo()"
              ></button>
            </div>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>

@if (acccess.hasAdminSecureGrpAccess || acccess.hasAppEditorSecureGrpAccess || acccess.hasModelEditorSecureGrpAccess) {
<div class="bulk-upload-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="app-stk-header">
        <span class="stk-c-header stk-container-header">
          <img class="stkh-img" src="../../../../assets/images/lob_maintenance.png" />
          <span class="stk-title">
            <span class="stk-header-title">Bulk Edit</span>
          </span>
        </span>
      </div>
      <span class="bulk-note"
        >Limit : 2000 rows. It is recommended to submit only records which have atleast one change and run bulk upload
        in non business hours if you are submitting more than 200 records</span
      >
      <div class="uitk-c-card__content">
        <div class="uitk-l-grid__row">
          <div class="uitk-l-grid__col--12">
            <div class="uitk-c-card">
              <div class="uitk-c-card__content">
                <div class="stk-table-container">
                  <div class="bulk-maintenance-modal-container">
                    <div class="custom-modal-body">
                      <div class="body-content">
                        <div class="upload-form">
                          <div class="form-panel">
                            <mat-grid-list cols="1" class="list" [rowHeight]="rowHeight">
                              <mat-grid-tile class="step-tiles">
                                <div class="form-f form-download-section">
                                  <mat-radio-group
                                    [(ngModel)]="uploadType"
                                    class="upload-type-group"
                                    (change)="uploadTypeChange($event)"
                                    aria-label="Select an option"
                                  >
                                    @for (type of uploadTypes; track type) {
                                    <mat-radio-button color="primary" [value]="type.value">
                                      {{ type.label }}
                                    </mat-radio-button>
                                    }
                                  </mat-radio-group>
                                </div>
                              </mat-grid-tile>
                              <mat-grid-tile class="step-tiles">
                                <div class="form-f form-download-section">
                                  <span class="upload-step1">
                                    Step #1: {{ isInitiativeSelected ? 'Select the initiative' : '' }}
                                    @if (isInitiativeSelected) {
                                    <span
                                      [attr.Pixel-tracking]="true"
                                      [attr.Pixel-title]="'Documentation'"
                                      class=" uitk-icon uitk-icon-info_hollow health md-icon excelandinfo-Icon-font"
                                      matTooltipPosition="left"
                                      aria-hidden="false"
                                      aria-label="information  icon"
                                      (click)="showRespectiveInfo()"
                                      style="cursor: pointer;"
                                    ></span>
                                    }
                                  </span>
                                  @if (isInitiativeSelected) {
                                  <span>
                                    <div class="initiative-dropdown">
                                      <app-dropdown-with-search
                                        [Pixeltracking]="true"
                                        placeholder="Select initiative"
                                        searchFlag="false"
                                        isMultiSelect="false"
                                        [dropdownData]="initiativeList"
                                        (selectionChange)="setSelectedInitiative($event)"
                                      ></app-dropdown-with-search>
                                    </div>
                                  </span>
                                  } @if (!isInitiativeSelected) {
                                  <span class="download-temaplte">
                                    <a [href]="Filepath" download>
                                      Download Template
                                    </a>
                                  </span>
                                  } @if (!isInitiativeSelected) {
                                  <span
                                    [attr.Pixel-tracking]="true"
                                    [attr.Pixel-title]="'Documentation'"
                                    class=" uitk-icon uitk-icon-info_hollow health md-icon excelandinfo-Icon-font"
                                    matTooltipPosition="left"
                                    aria-hidden="false"
                                    aria-label="information  icon"
                                    (click)="showRespectiveInfo()"
                                    style="cursor: pointer;"
                                  ></span>
                                  }
                                </div>
                              </mat-grid-tile>
                              <mat-grid-tile class="step-tiles" [ngClass]="{ 'mt-3': isInitiativeSelected }">
                                <div class="form-f form-info-section">
                                  <span class="upload-step2">
                                    Step #2:
                                  </span>
                                  <span class="">
                                    <a>
                                      {{
                                        isInitiativeSelected
                                          ? 'Download report and Add your data (changes only) in the report'
                                          : 'Add your data (changes only) in the template'
                                      }}
                                    </a>
                                    <br />
                                    @if (isInitiativeSelected) {
                                    <span>
                                      Click
                                      <a [href]="initiativeReportLink" target="blank">
                                        here
                                      </a>
                                      to download the report.
                                    </span>
                                    }
                                  </span>
                                </div>
                              </mat-grid-tile>
                              <mat-grid-tile class="step-tiles">
                                <div class="form-f form-upload-section">
                                  <span class="upload-step3">
                                    Step #3: Upload the filled in template
                                  </span>
                                  <span class="">
                                    <input
                                      type="file"
                                      [disabled]="isInitiativeSelected && selectedInitiative == null"
                                      #fileInput
                                      id="uploadFile"
                                      (change)="uploadFileEvt($event.target.files)"
                                      name="uploadFile"
                                      accept=".xlsx"
                                    />
                                  </span>
                                </div>
                              </mat-grid-tile>
                            </mat-grid-list>
                          </div>
                          @if (!showtable && missingColumns.length > 0) {
                          <dev class="form-footer">
                            <span class="label-invalid"
                              >{{ missingColumns.join(', ') }} columns are missing in uploaded file</span
                            >
                          </dev>
                          } @if (!showtable && isDataLarge) {
                          <dev class="form-footer">
                            <span class="label-invalid">File should not contain more than 2000 rows</span>
                          </dev>
                          }
                          <div class="form-footer">
                            @if (showtable) {
                            <div class="footer-label">
                              Total:
                              {{
                                dataSourceDetails_Pass.filteredData.length + dataSourceDetails_fail.filteredData.length
                              }}
                              &nbsp;<span class="label-invalid"
                                >Invalid: {{ dataSourceDetails_fail.filteredData.length }}</span
                              >
                              &nbsp;&nbsp;<span class="label-valid"
                                >Valid: {{ dataSourceDetails_Pass.filteredData.length }}</span
                              >
                            </div>
                            }
                            <div class="footer-buttons">
                              @if ((uploadType == 'Padu_Update') ||(uploadType == 'primary_Update')||(uploadType ==
                              'LOB_Update')||(uploadType == 'Capability_Mapping')||(uploadType ==
                              'Capability_Mapping')||(uploadType == 'Edit_Model')||(uploadType ==
                              'Enterprise_Initiatives')||(uploadType == 'initiative_update')) {
                              <span>
                                @if (!showtable) {
                                <button
                                  mat-mdc-raised-button
                                  class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                                  (click)="submitForm(false)"
                                  [disabled]="!showPreview"
                                >
                                  Preview
                                </button>
                                } @if (showtable) {
                                <button
                                  mat-mdc-raised-button
                                  class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                                  (click)="submitForm(true)"
                                  [disabled]="!fileToUpload || successPayload.length == 0"
                                >
                                  Submit
                                </button>
                                }
                              </span>
                              } @if (uploadType == 'Edit_Model_1') {
                              <span>
                                <button
                                  mat-mdc-raised-button
                                  class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                                  (click)="submitForm(false)"
                                  [disabled]="!fileToUpload"
                                >
                                  Submit
                                </button>
                              </span>
                              }
                              <button
                                mat-mdc-raised-button
                                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                                (click)="cancelUpload()"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                          @if (showtable) {
                          <!--*ngIf ="dataSourceDetails_fail.filteredData.length>0" <h6 style="background-color: rgb(244, 119, 119);"> Invalid count {{dataSourceDetails_fail.filteredData.length}}</h6> -->
                          <app-maintenance-table
                            [TABLE_CONFIG]="TABLE_CONFIG"
                            [COLUMNS]="TABLE_COLUMNS_FAIL"
                            [SORT_CONFIG]="sortConfig"
                            [dataSource]="dataSourceDetails_fail"
                            [SCHEMA]="DATA_SCHEMA"
                            [isInvalidTable]="true"
                            (filterApplied)="onFilterApplied($event)"
                            (filterCleared)="onFilterCleared($event)"
                          >
                          </app-maintenance-table>
                          <!-- <h6 style="background-color: aquamarine;"> Valid count {{dataSourceDetails_Pass.filteredData.length}}</h6> *ngIf= "dataSourceDetails_Pass.filteredData.length>0"-->
                          <app-maintenance-table
                            [TABLE_CONFIG]="TABLE_CONFIG"
                            [COLUMNS]="TABLE_COLUMNS_PASS"
                            [SORT_CONFIG]="sortConfig"
                            [dataSource]="dataSourceDetails_Pass"
                            [SCHEMA]="DATA_SCHEMA"
                            [isInvalidTable]="false"
                          >
                          </app-maintenance-table>
                          }
                        </div>
                      </div>
                    </div>
                    @if (showLoader) {
                    <div class="show-loader">
                      <app-loader> </app-loader>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
} @if (!acccess.hasAdminSecureGrpAccess && !acccess.hasAppEditorSecureGrpAccess &&
!acccess.hasModelEditorSecureGrpAccess) {
<div class="no-records-search">
  <div>
    <div class="errorTitle-search">Unauthorized to view this page. Please contact Techops team.</div>
  </div>
</div>
}
